export default class QuantityControls {
  constructor(theme, element, updateCart) {
    this.theme = theme;
    this.element = element;
    this.wrapper = this.element.querySelector('.quantity-controls');
    this.FADE_OUT_ANIMATION_DURATION = 800; // ms
    var self = this;

    this.element
      .querySelectorAll('.quantity-controls button.qty-plus')
      .forEach((item) => {
        item.addEventListener('click', function (e) {
          e.preventDefault();

          var qtyInput = this.closest('.quantity-controls').querySelector(
            'input.quantity-selector'
          );
          let stockAmt = this.closest('.quantity-controls').dataset.stockCount;
          let inventoryPolicy = this.closest('.quantity-controls').dataset.inventoryPolicy;
          let inventoryManagement = this.closest('.quantity-controls').dataset.inventoryManagement;
          let errorMsg = this.parentElement.nextElementSibling;

          const val = parseInt(qtyInput.value.toString(), 10);

          if (stockAmt && stockAmt > 0) {
            if (val < stockAmt || inventoryPolicy == "continue" || inventoryManagement != "shopify") {
              var newVal = val + 1;
            } else {
              errorMsg.classList.remove('d-none');
              newVal = stockAmt;
            }
          } else {
            newVal = val + 1;
          }

          qtyInput.value = newVal;

          if (updateCart) {
            self.updateCartItem(newVal);
          }
        });
      });

    this.element
      .querySelectorAll('.quantity-controls button.qty-minus')
      .forEach((item) => {
        item.addEventListener('click', function (e) {
          e.preventDefault();

          var qtyInput = this.closest('.quantity-controls').querySelector(
            'input.quantity-selector'
          );
          let stockAmt = this.closest('.quantity-controls').dataset.stockCount;
          let inventoryPolicy = this.closest('.quantity-controls').dataset.inventoryPolicy;
          let inventoryManagement = this.closest('.quantity-controls').dataset.inventoryManagement;
          let errorMsg = this.parentElement.nextElementSibling;

          const val = parseInt(qtyInput.value.toString(), 10);
          var newQty = val - 1 < 1 ? 1 : val - 1; // Never go below 1.
          qtyInput.value = newQty;

          if (stockAmt && stockAmt > 0) {
            if (newQty <= stockAmt || inventoryPolicy == "continue" || inventoryManagement != "shopify") {
              errorMsg.classList.add('d-none');
            }
          }

          if (updateCart) {
            self.updateCartItem(newQty);
          }
        });
      });

    this.element
      .querySelectorAll('input.quantity-selector')
      .forEach((item) => {
        item.addEventListener('change', function (e) {
          let stockAmt = this.closest('.quantity-controls').dataset.stockCount;
          let inventoryPolicy = this.closest('.quantity-controls').dataset.inventoryPolicy;
          let inventoryManagement = this.closest('.quantity-controls').dataset.inventoryManagement;
          let errorMsg = this.parentElement.nextElementSibling;
          var val = parseInt(e.currentTarget.value.toString(), 10);
          var qtyInput = this.closest('.quantity-controls').querySelector(
            'input.quantity-selector'
          );

          if (stockAmt && stockAmt > 0) {
            if (val > stockAmt && (inventoryPolicy !== "continue" || inventoryManagement == "shopify")) {
              qtyInput.value = stockAmt;
              errorMsg.classList.remove('d-none');
            } else {
              qtyInput.value = val;
              errorMsg.classList.add('d-none');
            }
          } else {
            qtyInput.value = val;
          }

          if (updateCart) {
            self.updateCartItem(val);
          }
        });
      });
  }

  updatePrices = (response) => {
    // Note: We don't currently construct the Cart page's rows dynamically
    //       (like we do in Cart drawer).
    //       If there are any discounts, refresh the form to let the existing
    //       logic handle it since we may need to add/remove line items.
    if (response.total_discount > 0) {
      // Quick fix: submit form (non-ajax)
      const updateQuantities = /** @type {HTMLInputElement} */ (document.querySelector(
        '#update_quantities'
      ));
      updateQuantities.click();
      return false;
    }

    response.items.forEach((item, index) => {
      var row = this.element.querySelector('.id-' + item.id);

      if (response.total_discount === 0) {
        // Remove discount lines / divs
        row.querySelector('.cart-table-price').innerHTML =
          '<div class="money">--</div>';
      }

      if (row) {
        // Item singular price.
        row.querySelector(
          '.cart-table-price .money'
        ).innerHTML = this.theme.formatMoney(item.original_price);

        // Line item total.
        row.querySelector(
          '.cart-table-line-price'
        ).innerHTML = this.theme.formatMoney(item.final_line_price);
      }
    });

    this.element.querySelector(
      '#cart-total-final-price'
    ).innerHTML = this.theme.formatMoney(response.total_price);

    // Free shipping msg update
    const freeShippingContainer = document.querySelector("[data-free-shipping-msg]");
    if (freeShippingContainer) {
      this.theme.fetchSection('/', 'free-shipping-msg', freeShippingContainer);
    }
  };

  updateCartItem = (num) => {
    this.wrapper.classList.add('cart-item-quantity-active');
    var fade = num <= 0;
    var delay = fade ? this.FADE_OUT_ANIMATION_DURATION : 0;

    // If number of items is 1, don't do anything. We still want to use the 'remove' link.
    if (num >= 1) {
      this.cartSetQuantity(delay).finally(() => {
        this.wrapper.classList.remove('cart-item-quantity-active');
      });
    } else {
      this.wrapper.classList.remove('cart-item-quantity-active');
    }
  };

  cartSetQuantity = async (delay) => {
    const self = this;
    const form = /** @type {HTMLFormElement} */ (document.querySelector(
      '#cartform'
    ));
    const formData = new FormData(form);
    const errorMessage = /** @type {HTMLDivElement} */ (document.querySelector(
      '.cart-error-box'
    ));

    errorMessage.innerText = '';

    try {
      const response = await (
        await fetch('/cart/update.js', {
          method: 'POST',
          body: formData
        })
      ).json();

      if (response) {
        setTimeout(() => {
          self.updatePrices(response);
        }, delay);
      }
    } catch (error) {
      console.log(error);
      errorMessage.innerText = 'Unable to update item quantity';
    }
  };
}
